import React from 'react'
import {TablePagination} from '@mui/material'
import ListTablePaginationDisplayedRows from './ListTablePaginationDisplayedRows'
import ListTablePaginationActions from './ListTablePaginationActions'
import {COMMON_CONSTANTS} from '../../CommonConstants'
import {formatNumberWithCommas} from '../../formatters/formatNumberWithCommas'

export interface ListTablePaginationProps {
    page: number
    count: number
    rowsPerPage: number
    labelRowsPerPage?: string
    rowsPerPageOptions?: number[]
    onPageChange: (event: React.MouseEvent<HTMLButtonElement> | null, page: number) => void
    onRowsPerPageChange?: React.ChangeEventHandler<HTMLTextAreaElement | HTMLInputElement>
}

const ListTablePagination: React.FC<ListTablePaginationProps> = props => {
    const {rowsPerPageOptions, ...restProps} = props

    return <TablePagination
        component="div"
        labelDisplayedRows={info => <ListTablePaginationDisplayedRows {...info} />}
        rowsPerPageOptions={(props.rowsPerPageOptions ?? COMMON_CONSTANTS.ROWS_PER_PAGE_SETTINGS)
            .map((option: number) => ({
                value: option,
                label: formatNumberWithCommas(option),
            }))}
        ActionsComponent={ListTablePaginationActions}
        // @ts-ignore
        onPageChange={props.onPageChange}
        onRowsPerPageChange={props.onRowsPerPageChange}
        {...restProps}
    />
}


ListTablePagination.displayName = 'ListTablePagination'
ListTablePagination.defaultProps = {
    labelRowsPerPage: '表示件数',
}
export default ListTablePagination
